// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Stack } from '@mui/material';
// Components, Layouts, Pages
import {
  AccountsReceivable,
  DailyLoadingAssignment,
  DeliveryMap,
  ForemanPerformanceTracking,
  OutstandingSiteVisit,
  Overbookings,
  PersonalCloseDate,
  Statistics,
  TodaysSchedule,
  TodaysTask,
  VehicleMaintenance,
} from '~/components/module/dashboard';
// Others
import { DashboardTabTypeEnum, RoleEnum } from '~/utils/enum/common';
import { StorageEnum } from '~/utils/enum/base';
// Styles, images, icons
import styles from './Dashboard.module.scss';

const cx = classNames.bind(styles);

const Dashboard = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  //#endregion Declare Hook

  //#region Selector
  const currentRole = JSON.parse(localStorage.getItem(StorageEnum.ROLE)!)[0];
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='dashboardPage' className={cx('container')}>
      {currentRole !== (RoleEnum.OPERATIONS_MANAGER || RoleEnum.WAREHOUSE_LEAD || RoleEnum.WAREHOUSE_STAFF) && (
        <>
          <Statistics type={DashboardTabTypeEnum.SALE} />

          <Grid2 container spacing={5}>
            <Grid2 size={6.5}>
              <Stack direction={'column'} spacing={5}>
                <AccountsReceivable description={t('dashboard_title_accounts_receivable_description')} />

                <AccountsReceivable
                  description={t('dashboard_title_accounts_receivable_description_two')}
                  isNotRequired={true}
                />

                <DeliveryMap />
              </Stack>
            </Grid2>
            <Grid2 size={5.5}>
              <Stack direction={'column'} spacing={5}>
                <TodaysTask />

                <PersonalCloseDate />

                <OutstandingSiteVisit />

                <Overbookings />
              </Stack>
            </Grid2>
          </Grid2>
        </>
      )}

      {currentRole === (RoleEnum.OPERATIONS_MANAGER || RoleEnum.WAREHOUSE_LEAD || RoleEnum.WAREHOUSE_STAFF) && (
        <>
          <Statistics type={DashboardTabTypeEnum.OPERATION} />

          <Grid2 container spacing={5}>
            <Grid2 size={6.5}>
              <Stack direction={'column'} spacing={5}>
                <TodaysTask />

                <ForemanPerformanceTracking />

                <DeliveryMap />
              </Stack>
            </Grid2>
            <Grid2 size={5.5}>
              <Stack direction={'column'} spacing={5}>
                <TodaysSchedule />

                <DailyLoadingAssignment />

                <VehicleMaintenance />

                <Overbookings />
              </Stack>
            </Grid2>
          </Grid2>
        </>
      )}
    </Box>
  );
};

export default Dashboard;
